import { generateTranslations } from '../../i18n/translation';

const namespace = 'practiceactivity/agreements';

const translations = generateTranslations(namespace, {
  headerPraksissted: {
    nb: 'Praksissted',
    en: 'Practice place',
  },
  headerAvtale: {
    nb: 'Avtale',
    en: 'Agreement',
  },
  headerDescription: {
    nb: 'Beskrivelse',
    en: 'Description',
  },
  headerHandlinger: {
    nb: 'Handlinger',
    en: 'Actions',
  },
  showAvtale: {
    nb: 'Vis avtale',
    en: 'Show agreement',
  },
  actionSlett: {
    nb: 'Slett',
    en: 'Delete',
  },
  panelHeaderFeil: {
    nb: 'Bestillinger og besvarelser som faller utenfor en avtale',
    en: 'Orders and responses that are not connected to an agreement.',
  },
  panelHeaderFeilSubtitle: {
    nb: 'Under er det listet opp bestillinger og besvarelser som ikke lenger hører til under en avtale. Dette kan bl.a. skje, dersom avtalen er oppdatert etter opprettelsen av aktiviteten, eller det har skjedd en feil. For å løse problemet med bestillinger/besvarelser som faller utenfor avtalen, må avtalen på nytt oppdateres til å inkludere praksisstedet, ellers kan de påvirkede bestillingene/besvarelsene slettes v.h.a. tabellen under. Det vil ikke sendes ut varsler til praksissteder ved sletting. Dersom varsling av praksissteder er aktuelt, må dette gjøres manuelt.',
    en: 'Orders and responses that are no longer connected to an agreement. This may happen if the agreement has been updated after the creation of the activity or an error has occurred. To solve the issue with orders/responses that are not connected to the agreement, the agreement must either be updated to include the practice place, or the affected orders/responses may be deleted using the table below. Practice places will not be notified about deletions. If it is necessary to notify practice places, this must be done manually.',
  },
  sourceTypeBesvarelse: {
    nb: 'Besvarelsen',
    en: 'The response',
  },
  sourceTypeBestilling: {
    nb: 'Bestillingen',
    en: 'The order',
  },
  warningOutsideAgreement: {
    nb: 'er utenfor aktivitetens avtaler.',
    en: 'is outside the activities agreements',
  },
  errorTypeMissingAvtalested: {
    nb: 'ligger ikke på eller mangler avtalested',
    en: 'is not on or is missing agreement place',
  },
  errorTypeMissingFromAktivitetskrav: {
    nb: 'mangler avtalested innenfor aktivitetskrav',
    en: 'is missing activity requirement',
  },
  errorTypeMissingFromTopTree: {
    nb: 'har avtalested utenfor hierarki',
    en: 'does not have place within hierarchy',
  },
  errorTypeMissingOmfattetPraksissted: {
    nb: 'tilhører ikke et sted omfattet av  avtalen',
    en: 'does not link to place in agreement',
  },
  errorTypeDeaktivertSted: {
    nb: 'tilhører et deaktivert avtalested',
    en: 'belongs to a deactivated place',
  },
  errorTypePathMismatch: {
    nb: 'ligger på ugyldig sti',
    en: 'resides on an invalid path',
  },
  errorTypeUtloeptSted: {
    nb: 'ligger på et utløpt avtalested',
    en: 'is linked to a expired place',
  },
  errorTypeUnderliggendeFeil: {
    nb: 'har underliggende feil',
    en: 'has subordinated errors',
  },
  errorTypeHierarkiskBestilling: {
    nb: 'er ugyldig fordi det ligger bestillinger over/under hverandre i samme hierarki.',
    en: 'is invalid because there are orders over/under each other in the same hierarchy.',
  },
  errorTypeOverlappendeAvtalestedHierarkier: {
    nb: 'er ugyldig fordi avtalen har avtalesteder med overlappende hierarkier.',
    en: 'is invalid because the agreement has agreement places with overlapping hierarchies.',
  },
  errorTypeOverlappingBesvarelse: {
    nb: 'overlapper. Det kan ikke meldes inn kapasitet ved samme praksissted flere ganger.',
    en: 'is overlapping. One cannot set capacity for the same practice place multiple times.',
  },
  errorTypeNotWithinAvtalePeriod: {
    nb: 'faller utenfor avtaleperioden.',
    en: 'falls outside agreement period.',
  },
  errorTypeInactivePraksistype: {
    nb: 'tilhører en avtale der aktivitetens praksistype er deaktivert.',
    en: "belongs to an agreement where the activity's practice type is deactivated.",
  },
  errorTypeInactivePraksisavtale: {
    nb: 'tilhører en deaktivert avtale.',
    en: 'belongs to a deactivated agreement.',
  },
  deleteSuccess: {
    nb: 'Alle merkede bestillinger og besvarelser ble slettet',
    en: 'All tagged orders and responses were deleted',
  },
  saveDelete: {
    nb: 'Lagre sletting av bestillinger/besvarelser',
    en: 'Save deletion of orders/responses',
  },
  errorModalTitle: {
    nb: 'Bekreft sletting',
    en: 'Confirm deletion',
  },
  errorModalSubtitle: {
    nb: 'Bekreft at du ønsker å slette de fjernede bestillingene og besvarelsene. Du kan også klikke "Avbryt", gjøre flere endringer og lagre senere, eller angre slettingen.',
    en: 'Confirm that you wish to delete all the removed orders and responses. You may also click "Cancel", make further action and save later, or undo the deletion altogether.',
  },
  cancel: {
    nb: 'Avbryt',
    en: 'Cancel',
  },
  errorModalEmptyTagged: {
    nb: 'Angre all sletting',
    en: 'Undo all deletions',
  },
  errorModalConfirmDelete: {
    nb: 'Bekreft sletting av bestillinger/besvarelser',
    en: 'Confirm deletion of orders/responses',
  },
  errorModalContentHeader: {
    nb: 'Bestillinger og besvarelser som vil slettes:',
    en: 'Orders and responses that will be deleted:',
  },
  bestilling: {
    nb: 'bestilling',
    en: 'order',
  },
  besvarelse: {
    nb: 'besvarelse',
    en: 'response',
  },
  unknown: {
    nb: 'Ukjent',
    en: 'Unknown',
  },
  bestillingAt: {
    nb: 'Tilhørende bestilling ved: ',
    en: 'Affected order is at: ',
  },
  numKapasitet: {
    nb: 'Innmeldt kapasitet er: ',
    en: 'The registered capacity is: ',
  },
  numBestilling: {
    nb: 'Antall bestilte plasser er:',
    en: 'The no. ordered places is:',
  },
  none: {
    nb: 'Ingen',
    en: 'None',
  },
});

export default translations;
